import { Briefcase, KeyRound, Stethoscope, Scale, Factory, Home, HardHat } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const GROUPS = [
  { icon: Briefcase, slug: "unternehmen", title: "Unternehmen & Büros", desc: "Saubere Arbeitsumgebungen für produktive Teams und einen professionellen Eindruck bei Kunden.", wide: true },
  { icon: KeyRound, slug: "hausverwaltungen", title: "Hausverwaltungen", desc: "Verlässliche Betreuung von Gemeinschaftsflächen und Treppenhäusern." },
  { icon: Stethoscope, slug: "praxen", title: "Praxen", desc: "Diskrete, gründliche Reinigung mit Blick für hygienische Anforderungen." },
  { icon: Scale, slug: "kanzleien", title: "Kanzleien", desc: "Repräsentative Sauberkeit für Empfang, Büros und Besprechungsräume." },
  { icon: Factory, slug: "gewerbe", title: "Gewerbeobjekte", desc: "Flexible Reinigungskonzepte für Ladenlokale, Hallen und Gewerbeflächen.", wide: true },
  { icon: Home, slug: "wohnanlagen", title: "Wohnanlagen", desc: "Gepflegte Treppenhäuser und Außenanlagen für Eigentümergemeinschaften." },
  { icon: HardHat, slug: "bauunternehmen", title: "Bauunternehmen", desc: "Baureinigung während und nach Bau-, Umbau- und Renovierungsmaßnahmen." },
];

export const TargetGroups = () => (
  <section id="unternehmen" className="bg-surface py-16 md:py-24" data-testid="target-groups-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Chapter number="02" label="Für Unternehmen" />
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-ink max-w-2xl">
          Professionelle Reinigung für Ihr Unternehmen
        </h2>
        <p className="mt-5 text-base sm:text-lg text-mutedtext leading-relaxed max-w-3xl">
          Jedes Objekt stellt andere Anforderungen. Deshalb erhalten Sie bei EMT-Reinigung keine
          Standardlösung, sondern ein Reinigungskonzept passend zu Ihrem Objekt und Ihrem Bedarf.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {GROUPS.map((g, i) => (
          <Reveal key={g.slug} delay={Math.min(i * 0.05, 0.3)} className={g.wide ? "lg:col-span-2" : ""}>
            <article
              className="h-full bg-white border border-gray-200 rounded-2xl p-7 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(11,25,44,0.22)] hover:border-brand/40"
              data-testid={`target-card-${g.slug}`}
            >
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 rounded-full bg-navy flex items-center justify-center shrink-0">
                  <g.icon className="w-5 h-5 text-ice" strokeWidth={1.8} />
                </div>
                <h3 className="font-heading text-xl font-medium text-ink">{g.title}</h3>
              </div>
              <p className="mt-4 text-sm text-mutedtext leading-relaxed">{g.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
